import { render } from "./Accessi.vue?vue&type=template&id=20d85bfa&scoped=true"
import script from "./Accessi.vue?vue&type=script&lang=js"
export * from "./Accessi.vue?vue&type=script&lang=js"

import "./Accessi.vue?vue&type=style&index=0&id=20d85bfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d85bfa"]])

export default __exports__